// extracted by mini-css-extract-plugin
export var box = "_3m-0";
export var check = "_3m-1";
export var checkboxButton = "_3m-6";
export var checkboxGroup = "_3m-5";
export var disabled = "_3m-7";
export var ghost = "_3m-9";
export var input = "_3m-2";
export var label = "_3m-4";
export var normal = "_3m-8";
export var uncheck = "_3m-3";